import { formatCurrency } from '../../utils/formatCurrency';

const VerifyPaymentModal = ({ isOpen, onClose, payment, onVerify }) => {
  if (!isOpen || !payment) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
      <div className="w-full max-w-lg m-4">
        <div className="bg-white rounded-lg shadow-xl">
          <div className="p-4 border-b flex justify-between items-center">
            <h3 className="text-lg font-medium text-gray-900">
              Verify Payment
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              ×
            </button>
          </div>

          <div className="p-4 space-y-4">
            {/* Payment Details */}
            <div className="bg-gray-50 p-4 rounded-md space-y-3">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-sm text-gray-500">Student</div>
                  <div className="font-medium">{payment.studentName}</div>
                </div>
                <div>
                  <div className="text-sm text-gray-500">Amount</div>
                  <div className="font-medium">{formatCurrency(payment.amount)}</div>
                </div>
                <div>
                  <div className="text-sm text-gray-500">Payment Type</div>
                  <div className="font-medium">
                    {payment.paymentType}
                    {payment.installmentNumber && (
                      <span className="text-gray-500">
                        {' '}
                        ({payment.installmentNumber}/{payment.totalInstallments}
                        )
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  <div className="text-sm text-gray-500">Payment Method</div>
                  <div className="font-medium">{payment.paymentMethod}</div>
                </div>
                <div>
                  <div className="text-sm text-gray-500">Receipt Number</div>
                  <div className="font-medium">
                    {payment.receiptNumber || '-'}
                  </div>
                </div>
                <div>
                  <div className="text-sm text-gray-500">Payment Date</div>
                  <div className="font-medium">
                    {new Date(payment.paymentDate).toLocaleDateString()}
                  </div>
                </div>
              </div>

              {/* Receipt Image/PDF */}
              {payment.receiptUrl && (
                <div className="mt-4">
                  <div className="text-sm text-gray-500 mb-2">
                    Attached Receipt
                  </div>
                  <a
                    href={payment.receiptUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-pink-700 hover:text-pink-900"
                  >
                    View Receipt
                  </a>
                </div>
              )}

              {/* Notes */}
              {payment.notes && (
                <div className="mt-4">
                  <div className="text-sm text-gray-500">Notes</div>
                  <div className="mt-1 text-sm">{payment.notes}</div>
                </div>
              )}
            </div>

            {/* Verification Actions */}
            <div className="flex justify-end space-x-3 pt-4 border-t">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={() => onVerify(false)}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md"
              >
                Decline
              </button>
              <button
                onClick={() => onVerify(true)}
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-md"
              >
                Accept Payment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPaymentModal;
